module.exports = function getResource(label, vars = []) {
    let resources = {
        myBillingAddrIsTheSame: 'My billing address is the same as my shipping address',
        iframeError: `Trouble connecting to ${vars[0]}. Please use a different payment method or try again later.`,
        legalNotice: `By clicking Continue to ${vars[0]}, I am instructing Sephora to send my order and billing information to ${vars[0]} and understand that information will be subject to the ${vars[0]} terms and the ${vars[0]} privacy policy.`
    };

    return resources[label];
};
